define([], function() {
    return {
        "path": "Ruta",
        "id_center": "ID Centro",
        "id_account": "ID Cuenta",
        "account_active": "Activar Cuenta",
        "account_disable": "Deshabilitar Cuenta",
        "sure_disable_account": "¿Seguro desea deshabilitar esta cuenta?",
        "sure_active_account": "¿Seguro desea activar esta cuenta?",
        "discontinue_plan": "Suspender Plan",
        "activate_plan": "Activar Plan",
        "supplant": "Suplantar",
        "info_account": "Información de la Cuenta",
        "change_plan": "Cambiar Plan",
        "nameCenter_required": "Nombre del centro es requerido",
        "id_account_required": "Id de la cuenta es requerido",
        "choose_type": "Escoja un tipo de centro",
        "name_required": "Nombre es requerido",
        "lastname_required": "Apellido es requerido",
        "username_required": "Nombre de Usuario es requerido",
        "email_required": "Email es requerido",
        "email_valid": "No es valido con el formato email",
        "password_required": "Contraseña es requerida",
        "min_char": "Mínimo 5 caracteres",
        "max_char": "Máximo 5 caracteres",
        "type_center": "Tipo de Centro",
        "username": "Nombre de Usuario",
        "isMulticenter": "Es Multicentro",
        "newCenter": "Nuevo Centro",
        "adminUser": "Usuario administrador",
        "siteName_required": "SiteName es requerido",
        "siteName": "SiteName",
        "plan_required": "Escoja un tipo de plan",
        "list": "Listado",
        "saved_changes": "Se guardaron los cambios",
        "state_search": "Buscar por estado",
        "password_not_match": "La contraseña no coincide",
        "change_Pwd": "Cambiar Contraseña",
        "sure_password": "¿Seguro desea cambiar la contraseña?",
        "new_password": "Nueva contraseña",
        "confirm_password": "Confirmar contraseña",
        "activate": "Activar",
        "integrations": "Integraciones",
        "save_integrations": "¿Seguro desea guardar los cambios de integraciones?",
        "save_change_plan": "¿Seguro desea cambiar el plan?",
        "boost_your_business": "¡Disfruta gratis por 15 días el panel de redes sociales y potencia la presencia online de tu negocio!",
        "content_your_schedule": "Crea tus contenidos, programa tus publicaciones, analiza y lleva un seguimiento de lo que sucede en tus perfiles.",
        "connect_your_networks": "Conecta tus redes con solo unos clics y explora todo el poder que tiene esta funcionalidad para ti y tu negocio.",
        "learn_more": "Conoce más",
        "skip": "Omitir",
        "mass_deletion": "Eliminación masiva",
        "alert_message_clients_delete": "Antes de eliminar clientes masivamente, descárgalos, ya que la acción es irreversible y perderás su información asociada. ",
        "elimination_question": "¿Deseas continuar con la eliminación?",
        "confirmation_client_deletion": "Si deseas confirmar la eliminación debes escribir la siguiente frase:",
        "confirmation_text_checker_client_deletion": "Sí, quiero eliminar los CLIENTES",
        "error_delete_clients": "Error al eliminar los clientes",
        "clients_deleted_sussesfully": "Los clientes han sido eliminados correctamente, tu sesion sera cerrada.",
        "error_elimination_text_checker_incorrect": "Para completar el proceso, la frase debe de ser exacta a la indicada",
        "waiting_message_clients_eliminations_on_process": "Estamos procesando la eliminación, este proceso puede tardar unos minutos, por favor, espere.",
        "integration_analytics": "redes sociales",
        "manage_your_networks": "Gestiona fácil y rápidamente todas tus redes sociales desde un único lugar... ¡Te enseñamos cómo hacerlo!",
        "connect_your_first_network": "En menos de 2 minutos conectá tu primera red y empezá a sacar provecho de todas las funcionalidades de tu Panel de Redes Sociales.",
        "create_content_on_your_networks": "Crea y programa el contenido de tus redes sociales, con el apoyo de nuestra herramienta de inteligencia artificial",
        "buy_now": "Cómpralo ahora",
        "integration_web_editor": "web editor",
        "expect_it_soon": "Espéralo pronto",
        "working_new_features": "Estamos trabajando en nuevas funcionalidades que te ayudarán a conectar tu negocio y tus Clientes al mundo digital.",
        "install": "Instalar",
        "uninstall": "Desinstalar",
        "_inactive": "Inactivo",
        "onepage_st": "One page sin dominio",
        "onepage-domain": "One page con dominio",
        "multipage_st": "Multipage sin dominio",
        "multipage-domain": "Multipage con dominio",
        "important": "Importante",
        "warning_downgrade_integration": "Al eliminar la integración de Web Editor, se reestablecerá el sitio web de esta cuenta y perderá la configuración que tenga realizada hasta el momento",
        "warning_uninstall_integration": "Si decides desinstalar la integración, la información se restablecerá. Al momento de reinstalarla, conservarás tu sitio web si activas el mismo plan o uno superior. En caso contrario, perderás la información.",
        "warning_upgrade_integration": "¿Listo para dar el siguiente paso? Confirma tu cambio de plan a Multipage y disfruta de las nuevas funcionalidades y beneficios.",
        "warning_select": "Debe seleccionar una opción.",
        "integration_yext_editor": "Rankings",
        "popup_upgrade_title_1": "¡<span>Mejora tu plan para beneficiarte </span> de nuevas funcionalidades!",
        "popup_upgrade_paragraph_1": "Si mejoras tu plan actual, podrás beneficiarte de funcionalidades que te ayudarán en el día a día de tu negocio: realiza campañas de email marketing a tus clientes, gestiona tus reservas o citas de manera sencilla o incluso haz mucho más fácil toda tu gestión administrativa. ¡No lo dudes! 🌠",
        "popup_upgrade_paragraph_2": "Si mejoras tu plan actual, podrás gestionar tus cobros, controlar el inventario de productos, programar y ver el histórico de tus gastos. ¡Simplifica, potencia y avanza hacia el éxito! 🌠",
        "center_management": "Gestión de centros",
        "successfully_saved": "Guardado con éxito",
        "center_type_Dance Academy": "Dance Academy",
        "center_type_arquitectura e interiorismo": "arquitectura e interiorismo",
        "center_type_automotriz": "automotriz",
        "center_type_construcción": "construcción",
        "center_type_hoteleria": "hoteleria",
        "center_type_industria": "industria",
        "center_type_inmobiliaria": "inmobiliaria",
        "center_type_servicios legales": "servicios legales",
        "center_type_servicio de mudanza": "servicio de mudanza",
        "center_type_servicios para el hogar": "servicios para el hogar",
        "center_type_belleza": "belleza",
        "center_type_depilación": "depilación",
        "center_type_hair": "cabello",
        "center_type_uñas": "uñas",
        "center_type_crossfit": "crossfit",
        "center_type_entrenador_personal": "entrenador personal",
        "center_type_dentistas": "dentistas",
        "center_type_salud": "salud",
        "center_type_salud ocular": "salud ocular",
        "center_type_educacion": "educacion",
        "center_type_educación": "educación",
        "center_type_escuela_deportiva": "escuelas deportivas",
        "center_type_escuelas deportivas": "escuelas deportivas",
        "center_type_estetica": "estética",
        "center_type_peluquerias": "peluquerias",
        "center_type_barberias": "barberias",
        "center_type_spa": "spa",
        "center_type_bienestar": "bienestar",
        "center_type_yoga": "yoga",
        "center_type_pilates": "pilates",
        "center_type_masajes": "masajes",
        "center_type_fitness": "fitness",
        "center_type_massage": "masaje",
        "center_type_baile": "baile",
        "center_type_musica": "música",
        "center_type_dojo": "dojo",
        "center_type_optica": "optica",
        "center_type_consultas": "consultas",
        "center_type_veterinaria": "veterinaria",
        "center_type_fisioterapeutas": "fisioterapeutas",
        "center_type_psicologos": "psicologos",
        "center_type_nutricion": "nutrición",
        "center_type_clinicas": "clinicas",
        "center_type_comidas": "comidas",
        "center_type_hoteleria y turismo": "hoteleria y turismo",
        "center_type_otro": "otro",
        "center_type_domicilio": "domicilio",
        "center_type_cadenas": "cadenas",
        "center_type_retail": "minorista",
        "accounts": "Cuentas",
        "message_confirmation_account_editing": "Estás a punto de guardar cambios que afectarán a tu cuenta hija. ¿Deseas continuar?",
        "legal_conditions_text": "Condiciones legales",
        "privacy_policies_text": "Politicas de privacidad",
        "newAccount": "Nueva Cuenta",
        "_accounts": "Cuentas",
        "search_account": "Buscar por cuenta",
        "type_account": "Tipo de la cuenta",
        "name_account": "Nombre de la cuenta",
        "add_&_buy": "Agregar y comprar",
        "no_accounts_available": "Ya no tienes cuentas disponibles",
        "add_another_account": "¿Te gustaría agregar otra cuenta?",
        "expand_your_rach": "¡Expande tu alcance! Con una cuenta adicional",
        "plans_subscriptions": "Planes y precios",
        "name_account_required": "Nombre de la cuenta es requerido",
        "choose_account_type": "Seleccione un tipo de cuenta",
        "custom_plan_description": "¡Aquí tienes el plan diseñado a tu medida!  Recuerda que puedes configurar las funcionalidades, los módulos y los complementos en tus cuentas según tus preferencias. Si deseas realizar algún cambio, contacta con tu representante comercial.",
        "account_cancelled": "Esta cuenta quedará anulada",
        "uninstall_warning_account": "Las integraciones activas se desvincularán automáticamente en la fecha mencionada. Si deseas reactivar la cuenta, deberás añadir nuevamente las integraciones.",
        "desist_cancel_account": "Puedes desistir de la anulación antes de la fecha programada sin afectar las integraciones.",
        "unsubscribe_account_warning": "¿Estás seguro de que deseas desistir de la baja de esta cuenta?",
        "date_creation": "Fecha de creación",
        "next_charge": "Próximo cargo",
        "number_employees": "No. de empleados",
        "activate_account": "Activar esta cuenta",
        "programmed_account_cancellation": "Baja de cuenta programada",
        "desist_cancellation_account": "Desistir de la baja de la cuenta",
        "unsubscribe_account": "Dar de baja esta cuenta",
        "choose_our_plans": "Elige uno de nuestros planes y aprovecha al máximo todos sus beneficios.",
        "pwd_regexp": "Mínimo 8 caracteres con letras, números y caracteres especiales.",
        "reactivate_account_description": "Tu cuenta se activará de nuevo. Por favor, selecciona nuevamente un plan para esta cuenta.",
        "uninstall_warning_account_2": "Las integraciones activas se desvincularán automáticamente. Si deseas reactivar la cuenta, deberás añadir nuevamente las integraciones.",
        "programmed_change": "Cambio programado",
        "programmed_cancellation": "Baja programada",
        "desist_from_change": "Desistir del cambio",
        "desist_from_discharge": "Desistir de la baja",
        "change_functionality": "Cambiar funcionalidad",
        "description_install_integration": "¡Estás a punto de dar un gran paso al realizar esta instalación!",
        "integration_tools": "Te invitamos a sumergirte en un mundo de herramientas diseñadas para potenciar tu negocio.",
        "description_uninstall_integration": "Si decides desinstalar tu integración, se restablecerá y perderás la información.",
        "desist_uninstallation_integration": "Puedes desistir de la desinstalación antes de la fecha programada sin afectar la integración.",
        "description_update_integration": "Confirma tu cambio de plan y disfruta de las nuevas funcionalidades y beneficios.",
        "additional_text_update_integration": "El primer cobro se ajustará proporcional a la fecha del próximo cargo.",
        "account_sheet": "Ficha de la cuenta",
        "modules": "Módulos",
        "desc_plan_discovery": "El futuro de tu marca blanca está aquí. Con las Cuentas",
        "desc_plan_discovery_2": "innova y adáptate a tus clientes. Elige la cantidad, personalízalas y lidera el mercado.",
        "one_time_payment": "Único pago",
        "white_label_config": "Configuración Marca blanca",
        "setup_cost": "La primera vez pagarás {price} que incluye la configuración Marca Blanca.",
        "second_payment": " Los pagos siguientes serán de {price}.",
        "choose_number_accounts": "Escoge el número de cuentas",
        "choose_number_accounts_2": "para tu negocio",
        "_analytics": "Panel de redes sociales",
        "_web_editor": "Web editor",
        "users": "Usuarios",
        "unlimited_users": "Usuarios ilimitados",
        "alert_manage_user": "¿Está seguro de actualizar el número de empleados?",
        "select_an_option": "seleccione una opción",
        "select_number_employees": "Selecciona el número de empleados que quieres activar",
        "sure_activate_module": "¿Estás seguro de activar el módulo de",
        "sure_deactivate_module": "¿Estás seguro de desactivar el módulo de",
        "manage_number_users": "Gestionar número de usuarios",
        "manage_customers": "Gestiona y entiende cómo se comportan tus clientes.",
        "comunication_customers": "Mejora la comunicación con tus clientes e impacta en tus estrategias.",
        "manage_schedules": "Gestiona tus agendamientos, y potencia tu negocio.",
        "manage_finances": "Gestiona tus finanzas y haz seguimiento a tu negocio.",
        "_appointment": "Agendamiento",
        "administration": "Administración",
        "do_you_want_add_integration": "¿Deseas añadir esta integración a la cuenta?",
        "expand_reach_additional": "¡Expande tu alcance con una integración adicional!",
        "remember_integration_charge": "Recuerda que la integración tiene un costo adicional de",
        "sure_want_cancel_change": "¿Seguro que quieres anular el cambio?",
        "sure_change_account_pro": "¿Estás seguro que deseas que esta cuenta dejé de ser ",
        "account_will_longer_PRO": "Esta cuenta dejará de ser PRO a partir del",
        "cancel_account_change": "Puedes desistir del cambio de cuenta antes de la fecha programada sin afectaciones.",
        "account_will_become_PRO": "Esta cuenta pasará a ser PRO a partir del",
        "mark_account_PRO": "Estás seguro que deseas marcar esta cuenta como",
        "configure_account_as": "Para configurar esta cuenta como",
        "need_add_plan": "necesitas añadirla a tu plan.",
        "confirm_want_access_upselling": "Confirma si deseas acceder a la sección de upselling para añadir más cuentas",
        "your_plan": "a tu plan",
        "change_additional_cancelled": "Tu cambio a cuenta Adicional se anulará.",
        "change_additional_account": "Cambio a cuenta Adicional programado para",
        "cancel_change_additional_account": "Anular cambio a cuenta Adicional",
        "uncheck_PRO_account": "Desmarcar como cuenta PRO",
        "mark_PRO_account": "Marcar como cuenta PRO",
        "mark_PRO": "Marcar como Pro",
        "additional_account": "Cuenta adicional",
        "sure_want_mark_account_additional": "¿Estás seguro que deseas marcar esta cuenta como Adicional?",
        "remember_additional_account_charge": "Recuerda que las cuentas adicionales generan un cobro de",
        "integration_additional_cost": "Las integraciones que decidas instalar en esta cuenta tendrán un costo adicional.",
        "would_prefer_additional": "o prefieres que sea adicional",
        "manage_users": "Gestionar usuarios",
        "management": "Administración",
        "order_successfully": "Tu orden fue creada con éxito",
        "discovery_plan": "Plan Discovery",
        "go_to_payments": "Ir a mis pagos",
        "processing_your_payment": "Estamos procesando tu pago de forma segura. Este proceso podría tardar unos minutos en verse reflejado.",
        "continue_purchase": "¿Deseas continuar con la compra?",
        "transaction_number": "Nº de transacción",
        "confirm_buy_subscription_1": "¿Listo para dar el siguiente paso?",
        "confirm_buy_subscription_2": "Confirma tu cambio de plan.",
        "custom_plan": "Custom plan",
        "addons": "Add-ons",
        "payment_history": "Historial de pagos",
        "description_upgrade_subscription": "Ahora tendrás {quantityAccounts} cuentas. Te cobraremos {pricePlan} menos un descuento por el pago anterior.",
        "your_plans_upgrade": "Tus planes disponibles para actualizar",
        "choose_accounts_business": "Escoge el número de cuentas para tu negocio",
        "upgrade_your_plan": "Actualizar tu plan",
        "you_need_more_accounts": "Necesitas más cuentas para tu agencia",
        "desccription_more_accounts_upgrade": "¿Necesitas más de 10 cuentas? Personaliza el plan a tu medida con la ayuda de nuestros expertos.",
        "description_additionals_plan": "¡Multiplica el rendimiento de tus cuentas adicionales con integraciones que las impulsan al siguiente nivel!",
        "_appointments": "Agendamientos",
        "view_invoice": "Ver Factura",
        "discovery_accounts": "Discovery con {quantityAccount} {accounts}",
        "not_processed_payment": "Aún no procesamos tu pago",
        "necessary_process_payment": "Es necesario procesar tu pago para que puedas seguir disfrutando de todas las ventajas de tu cuenta.",
        "payment_link": "Link de pago",
        "pay_subscription": "Pagar mi suscripción",
        "title_warning_due_payment": "Tienes un pago pendiente",
        "desc_warning_due_payment": "No hemos procesado tu pago. Revisa la tarjeta vinculada o tu bandeja de entrada para completar el pago.",
        "do_not_access": "No tienes acceso a",
        "problems_accessing": "Estamos experimentando problemas para acceder a esta funcionalidad. Por favor, contacta con soporte para obtener más información.",
        "contact_support": "Contactar con soporte",
        "pending_payment": "Pago pendiente",
        "confirm_purchase_custom_plan": "¿Estás seguro que deseas adquirir este plan personalizado?",
        "employee_without_permissions": "No puedes realizar esta acción, contacta con tu supervisor para gestionar permisos",
        "account": "Cuenta",
        "CRM": "CRM",
        "_id": "ID",
        "additional_accounts": "Cuentas adicionales",
        "desc_additional_accounts": "Además de las cuentas incluidas en tu plan, tienes la opción de adquirir cuentas adicionales. Es importante que sepas que estas cuentas adicionales y sus integraciones se cobrarán por separado, fuera del costo de tu plan.",
        "addons_additional_accounts": "Integraciones para cuentas adicionales",
        "info_rankings": "Depende de la disponibilidad de tu país",
        "tooltip_number_accounts": "Cantidad de cuentas adquiridas en el plan",
        "pro": "PRO",
        "your": "Tus",
        "current_subscription": "Tu suscripción actual",
        "change_or_add_card": "Aquí podrás cambiar o agregar las tarjetas para el pago de tu suscripción.",
        "access": "Acceder",
        "number_accounts": "N. cuentas",
        "tooltip_accounts_pro": "Las cuentas PRO son la cantidad de cuentas incluídas en tu suscripción actual",
        "configure_customers": "Podrás configurar lo que vas a ofrecer a tus clientes",
        "search_by_modules": "Buscar por módulos",
        "search_by_category": "Buscar por categoría",
        "accounts_pro": "Cuentas PRO",
        "search_by_account_type": "Buscar por tipo de cuenta",
        "search_by_integration": "Buscar por integración instalada",
        "info_marketing": "1000 mails/mes para campañas (no descontables de notificaciones)",
        "view_receipt": "Ver comprobante de pago",
        "suspend": "Suspendido",
        "change_pro_account": "Cambio a cuenta PRO programado para",
        "cancel_change_pro_account": "Anular cambio a cuenta PRO",
        "change_pro_cancelled": "Tu cambio de cuenta adicional a cuenta PRO se anulará.",
        "scheduled_PRO": "Programado a PRO",
        "scheduled_additional": "Programado a Adicional",
        "search_by_scheduled_account_type_change": "Buscar por cambio de tipo de cuenta programado",
        "without_modules": "Sin módulos",
        "contact_sales_representative": "Contactar con mi representante de ventas",
        "search_by_name_ID": "Buscar por nombre o ID",
        "addons_activate_modal_desc": "¿Estás seguro de activar el Addon de {addonName}?",
        "addons_deactivate_modal_title": "🚨 Atención",
        "addons_deactivate_modal_desc": "Al desactivar el Addon de {addonName}, se eliminarán todos los envíos programados de tus clientes",
        "addons_deactivate_modal_confirm_button": "Si, quiero desactivar el Addon",
        "addons_configure_packages_button": "Configura el Plan Recurrente",
        "addons_configure_packages_modal_title": "Activación de mensajes",
        "addons_configure_packages_modal_recurring_title": "Plan Recurrente",
        "addons_configure_packages_modal_recurring_desc": "Activa el paquete recurrente de mensajes que se cargará mensualmente a tu cliente. *Recuerda que podrás editarlo cuando desees",
        "addons_configure_packages_modal_recurring_button_save": "Guardar",
        "addons_waba_label": "WhatsApp",
        "addons_waba_options_canUseGlobalConfig": "Linea de {agencyName}",
        "addons_waba_options_canUseOwnConfig": "Linea del cliente",
        "addons_info_block_messages_waba": "<strong>No. de mensajes de Whatsapp disponibles:</strong> {quantity}",
        "addons_info_block_messages_email": "<strong>No. de mails disponibles:</strong> {quantity}",
        "addons_info_block_messages_sms": "<strong>No. de SMS disponibles:</strong> {quantity}",
        "addons_configure_packages_modal_recurring_success": "Plan actualizado con éxito",
        "addons_add_package_button": "Añade Bolsas de Mensajes",
        "addons_add_package_modal_title": "Activación de mensajes",
        "addons_add_package_modal_subtitle": "Bolsas de Mensajes",
        "addons_add_package_modal_desc": "Añade bolsas de mensajes de WhatsApp según la necesidad de tus clientes, recuerda que no caducan y puedes comprar cuantas veces quieras.",
        "addons_add_package_modal_button_save": "Añadir",
        "addons_add_package_modal_error_select": "Selecciona una opción",
        "addons_add_package_modal_success": "Mensajes añadidos con éxito",
        "cookies_policies": "Políticas de cookies",
        "activate_cookie_policies": "Activar políticas de cookies",
        "addons_info_block_renewal_date": "Fecha de renovación: {date}",
        "error::collect_bill_error": "Se produjo un error al intentar procesar el cobro",
        "addons_configure_packages_modal_recurring_agency_upgrade": "Vas a aumentar el plan de la cuenta <b>{centerName}</b> a {quantity} mensajes mensuales, con un nuevo costo de <b>{amount}</b>. En este momento se cobrará de forma inmediata la diferencia de lo ya cobrado en el plan anterior, pero a partir del <b>{dueDate}</b> se cobrarán <b>{amount}</b>.<br><br>¿Te gustaría continuar con el cambio?",
        "addons_configure_packages_modal_recurring_agency_downgrade": "Vas a reducir el plan de la cuenta <b>{centerName}</b> a {quantity} mensajes mensuales, con un nuevo costo de <b>{amount}</b>. Este costo se aplicará a partir de tu próxima fecha de pago, el <b>{dueDate}</b>.<br><br>¿Te gustaría continuar con el cambio?",
        "addons_configure_packages_modal_recurring_agency_cancel": "Vas a cancelar el plan de la cuenta <b>{centerName}</b>. Este cambio se aplicará a partir de la fecha de vencimiento, el <b>{dueDate}</b>.<br><br>¿Te gustaría continuar con el cambio?",
        "addons_configure_packages_modal_recurring_button_buy": "Modificar Plan",
        "addons_add_package_modal_desc_agency": "Vas a añadir {quantity} mensajes a la cuenta <b>{centerName}</b>, con un costo de <b>{amount}</b>. <br><br>¿Te gustaría continuar con tu compra?",
        "addons_add_package_modal_button_buy": "Comprar",
        "is_Multi_Business": "Es Multinegocio",
        "whatsapp_init_message_label": "Personaliza el mensaje inicial que verán tus clientes al contactarte por WhatsApp.",
        "whatsapp_init_message": "👋🏽 ¡Hola! Vi tu página y me gustaría obtener más información sobre sus servicios 😀",
        "whatsapp_placeholder_message": "Mensaje de inicio",
        "agency_addon_waba_config_section_phone_link_modal_warning": "¡Atención! Al vincular tu línea, esta será <u>exclusiva</u> para las notificaciones de WhatsApp. No podrás usarla para llamadas, ni mensajes desde el celular. Para evitar bloqueos, te recomendamos sea una línea postpago.",
        "create_content_on_your_AI": "Consulta la información de tus productos, gestiona tus tareas diarias o crea contenido para tus redes sociales en segundos con la ayuda de Luna",
        "open_linda": "Abrir Luna",
        "addons_configure_packages_modal_recurring_agency_upgrade_title": "¡Confirmación de tu aumento del Plan Recurrente!",
        "addons_configure_packages_modal_recurring_agency_downgrade_title": "¡Confirmación de tu disminución de Plan Recurrente!",
        "addons_configure_packages_modal_recurring_agency_cancel_title": "¡Confirmación de tu cancelación de Plan Recurrente!",
        "upgrades_integrations": "Upgrades de Integraciones",
        "text_upgrades_integrations": "Elige hacia dónde dirigir el call to action (CTA) en nuestra landing por defecto, o introduce tu propia landing según tus necesidades",
        "search_by_email": "Buscar por email",
        "electronic_invoicing": "Facturación electrónica"
};
});